import { Drawer, Table } from "@mantine/core"
import { Missing, CountryCell } from "@tfg/ui"
import _ from "lodash"
import { useTranslation } from "react-i18next"

import { ProductResponses } from "@tfg/types/endpoints/products"

import { TranslatedTextContent } from "~/components/TranslatedTextContent.tsx"
import { COUNTRIES } from "~/utils/countries"

interface Props {
  component: ProductResponses.RDUEComponent
  opened: boolean
  onClose: () => void
}

export const ComponentDetailsDrawer = ({
  component,
  opened,
  onClose,
}: Props) => {
  const { t } = useTranslation("regulations")

  const definitions = _.uniqBy(
    component.materials.flatMap((material) =>
      material.customFields.map((customField) => customField.definition)
    ),
    "id"
  )

  return (
    <Drawer opened={opened} onClose={onClose} size="xl" position="right">
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("columns.rdue.component.material.name")}</Table.Th>
            <Table.Th>
              {t("columns.rdue.component.material.scientificName")}
            </Table.Th>
            <Table.Th>{t("columns.rdue.component.material.country")}</Table.Th>
            {definitions.map((definition) => (
              <Table.Th key={definition.id}>
                <TranslatedTextContent textContent={definition.textContent} />
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {component.materials.map((material, materialIndex) => (
            <Table.Tr key={materialIndex}>
              <Table.Td>
                <TranslatedTextContent
                  textContent={material.type.typeTextContent}
                />
              </Table.Td>
              <Table.Td>{material.type.typeTextContent.originalText}</Table.Td>
              <Table.Td>
                <CountryCell
                  countryIso3166={material.productionSite?.countryIso3166}
                  countriesMapper={COUNTRIES}
                />
              </Table.Td>
              {definitions.map((definition) => {
                const value = material.customFields.find(
                  (cf) => cf.definition.id === definition.id
                )?.customFieldValue.value

                return value ? (
                  <Table.Td key={definition.id}>{value}</Table.Td>
                ) : (
                  <Missing key={definition.id} />
                )
              })}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Drawer>
  )
}
